<template>
  <div id="message">
    <div class="box">
      <el-tabs type="border-card">
        <el-tab-pane label="基本信息">
          <el-form ref="form" :model="form" label-width="150px">
            <div style="margin:20px;font-weight: bold;">个人信息:</div>
            <el-form-item label="姓名:">
              <el-input v-model="form.nickname" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="联系方式:">
              <el-input v-model="form.bind_mobile" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="单位:">
              <el-input v-model="form.organization" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="地址:">
              <el-input v-model="form.address" style="width:300px"></el-input>
            </el-form-item>

            <div style="margin:20px;font-weight: bold;">发票信息:</div>
            <el-form-item label="发票抬头:">
              <el-input v-model="invoice_title" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号:">
              <el-input v-model="taxpayer" style="width:300px"></el-input>
            </el-form-item>

            <div style="margin:20px;font-weight: bold;">预付分类:</div>
            <el-form-item>
              <el-radio-group v-model="radio" @change="classify">
                <el-radio label="试剂,耗材"></el-radio>
                <el-radio label="技术服务"></el-radio>
                <el-radio label="仪器(常用小型)"></el-radio>
              </el-radio-group>
            </el-form-item>
<!-- 
            <div style="margin:20px;font-weight: bold;">支付密码设置:</div>
            <el-form-item>
              <el-button @click="set_pay">点击设置支付密码</el-button>
            </el-form-item> -->
            <!-- <el-form-item label="确认密码:">
              <el-input v-model="pay_pass1" style="width:300px" show-password maxlength="6"></el-input>
              <div>支付密码为6位不连续的数字</div>
            </el-form-item>-->
            <el-form-item style="margin:50px">
              <el-button style="width:200px" type="primary" @click="submit" :loading="loading">提交</el-button>
            </el-form-item>

            <el-form-item>
              <div style="width:400px;float:right">
                <div>宝枫林(Bioflin)</div>
                <div>运营单位 : 业立生物科技(上海)股份有限公司</div>
                <div>电话 : 400-821-3401</div>
                <div>邮箱 : jack@bioflin.com</div>
                <el-link href="https://www.bioflin.com" target="_blank">网址 : https://www.bioflin.com</el-link>
                <div>地址 : 上海市徐汇区肇嘉浜路789号均瑶国际广场17楼E3座</div>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="预付款规则">
          <div v-html="rule"></div>
        </el-tab-pane>
        <!-- <el-tab-pane label="使用说明">
          <div>支付密码</div>
        </el-tab-pane> -->
      </el-tabs>
    </div>
<!-- 
    <el-dialog title="修改支付密码" :visible.sync="PW2Dialog1" width="40%">
      <div style="margin-top:20px;width:80%;">
        <el-form label-position="right" label-width="120px">
          <el-form-item>
            <div class="lv2Text" style="font-weight:bold">已绑定手机：{{phone}}</div>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入6位验证码" maxlength="6" show-word-limit v-model="form1.code" >
              <el-button slot="append" :disabled="smsDis" @click="getSMS">{{text1}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="支付密码：">
            <el-input type="password" maxlength="6" show-password  v-model="form1.newPW1"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：">
            <el-input type="password" maxlength="6" show-password v-model="form1.newPW2"></el-input>
            <span style="color:#e2211c">支付密码为六位不连续的数字</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="PW2Dialog1 = false">取消</el-button>
        <el-button type="primary" @click="submit2">确定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      smsDis: false,
      phone: "",
      text1: "获取验证码",
      PW2Dialog1: false,
      loading: false,
      classify1: null,
      invoice_title: "",
      taxpayer: "",
      radio: null,
      pay_pass1: "",
      pay_pass: "",
      form: {},
      form1: {},
      serve: this.$store.state.serve,

      token: this.$cookies.get("token"),
      mobile: this.$cookies.get("user"),
      rule:
        '<p style="line-height:125%"><strong><span style="font-family:宋体">宝枫林预付款活动</span></strong></p><p style="line-height:125%"><span style="font-family: 宋体">&nbsp;</span></p><p style="line-height:125%"><span style="font-family:宋体">·<strong>活动时间：</strong>2019年11月01日-2019年12月31日</span></p><p style="line-height:125%"><span style="font-family:宋体">·<strong>活动内容：</strong></span></p><p style="text-indent:14px;line-height:125%"><span style="font-family:宋体">活动产品：试剂、耗材</span></p><p style="text-indent:14px;line-height:125%"><span style="font-family:宋体">参与对象：所有客户均可参加</span></p><p style="line-height:125%"><strong><span style="font-family:宋体">·活动方案：</span></strong></p><p style="text-indent:14px;line-height:125%"><span style="font-family:宋体">1</span><span style="font-family:宋体">）预付款＜1万元，立即享受现款最低折扣价</span></p><p style="text-indent:14px;line-height:125%"><span style="font-family:宋体">2</span><span style="font-family:宋体">）预付款≥1万元，在已享有现款最低折扣价基础上，再享受98折优惠，并赠送价值100元客户指定礼品</span></p><p style="text-indent:14px;line-height:125%"><span style="font-family:宋体">3</span><span style="font-family:宋体">）预付款≥3万元，在已享有现款最低折扣价基础上，再享受96折优惠，并赠送价值300元客户指定礼品</span></p><p style="text-indent:14px;line-height:125%"><span style="font-family:宋体">4</span><span style="font-family:宋体">）预付款≥5万元，在已享有现款最低折扣价基础上，再享受94折优惠，并赠送价值500元客户指定礼品<a></a></span></p><p style="line-height:125%"><strong><span style="font-family:宋体">·活动说明：</span></strong></p><p style="text-indent:14px;line-height:125%"><span style="font-family:宋体">1</span><span style="font-family:宋体">）预付款到账后，立即享受折扣优惠及赠送礼品</span></p><p style="text-indent:14px;line-height:125%"><span style="font-family:宋体">2</span><span style="font-family:宋体">）本活动不与其他优惠活动同时参与</span></p><p style="text-indent:14px;line-height:125%"><span style="font-family:宋体">3</span><span style="font-family:宋体">）最终解释权归业立生物科技（上海）股份有限公司所有</span>'
    };
  },
  activated() {
    this.$store.state.user_location = "预付款";
  },
  created() {
    this.geren();
  },
  methods: {
    alert_success(message) {
      this.$message({
        message: message,
        type: "success",
        offset: 200
      });
    },
    alert_error(message) {
      this.$message({
        message: message,
        type: "error",
        offset: 200
      });
    },
    submit2() {
      let param = new FormData();
      param.append("mobile", this.mobile);
      param.append("token", this.token);
      param.append("code", this.form1.code);
      param.append("new_pay", this.form1.newPW1);
      param.append("new_pay1", this.form1.newPW2);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios
        .post(
          this.serve + "/personal/change_pay_password2",
          param,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.alert_success("支付密码已修改");
            this.PW2Dialog1 = false;
          } else {
            this.alert_error(res.data.msg);
          }
        });
    },
    getSMS() {
      this.axios
        .get(this.serve + "/personal/send_pay_pass_note", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.alert_success("验证码已发送!");
            var t = 59;
            var that = this;
            this.smsDis = true;
            that.text1 = "60秒后重新发送";
            var tm = setInterval(() => {
              that.text1 = t + "秒后重新发送";
              t--;
              if (t < 0) {
                clearInterval(tm);
                that.text1 = "获取短信";
                that.smsDis = false;
              }
            }, 1000);
          } else {
            this.alert_error(res.data.msg);
          }
        });
    },
    getphone() {
      this.axios
        .get(this.serve + "/personal/get_bind_mobile", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.phone = res.data.data;
        });
    },
    set_pay() {
      this.PW2Dialog1 = true;
      this.getphone();
    },
    classify(v) {
      this.classify1 = v;
    },
    geren() {
      this.axios
        .get(this.serve + "/personal/personal_info", {
          params: {
            token: this.token,
            mobile: this.mobile
          }
        })
        .then(res => {
          //   console.log(res)
          if (res.data.status == "success") {
            this.form = res.data.data;
          }
        });
    },
    submit() {
      this.loading = true;
      this.axios
        .get(this.serve + "/personal/applyAdvance", {
          params: {
            mobile: this.mobile,
            token: this.token,
            name: this.form.nickname,
            link_phone: this.form.bind_mobile,
            address: this.form.address,
            company: this.form.organization,
            invoice_head: this.invoice_title,
            duty_code: this.taxpayer,
            advance_class: this.classify1
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    }
  }
};
</script>
<style lang="scss">
#message {
  .dialog {
    .t3 {
      margin-top: 30px;
    }
    .t1 {
      font-size: 18px;
      margin-bottom: 10px;
    }
    .t2 {
      margin-bottom: 20px;
    }
    .title {
      border-bottom: 1px solid #ddd;
      text-align: center;
    }
  }
  .tab2-item {
    border: 1px solid #ddd;
    .title {
      background-color: #f9f9f9;
      color: #333;
      padding: 10px 15px;
    }
    .content {
      padding: 20px 15px 10px 15px;
      line-height: 1.5em;
    }
    margin-bottom: 20px;
  }
  .state1 {
    background-color: #f33934;
    color: #fff;
    display: inline-block;
    border-radius: 20px;
    width: 80px;
    padding: 8px 0;
    text-align: center;
  }
  .state2 {
    background-color: #808080;
    color: #fff;
    display: inline-block;
    border-radius: 20px;
    width: 80px;
    padding: 8px 0;
    text-align: center;
  }
  .cover {
    height: 150px;
    width: 100%;
    margin: 10px 0;
  }
  .tab1Iteam {
    border: 1px solid #ddd;
    padding: 5px 10px;
    margin-bottom: 20px;
  }
  .box {
    background-color: #fff;
  }
  .table {
    padding: 20px;
  }
}
</style>